export const dropdownList = [
  {
    id: 1,
    title: "Font family",
    value: "fontFamily",
    option: [
      "Built-in font",
      "Helvetica",
      "Times New Roman",
      "Microsoft YaHei",
      "SimSun",
      "SimHei",
      "Arial",
    ],
  },
  {
    id: 2,
    title: "Line height",
    value: "lineHeight",
    option: ["Default", "1", "1.25", "1.5", "1.75", "2"],
  },
  {
    id: 3,
    title: "Text alignment",
    value: "textAlign",
    option: ["Default", "Left", "Justify", "Right"],
  },
  {
    id: 4,
    title: "Conversoin of Chinese",
    value: "convertChinese",
    option: [
      "Default",
      "Simplified To Traditional",
      "Traditional To Simplified",
    ],
  },
];
export const speedList = {
  id: 3,
  title: "Speed",
  value: "speed",
  option: [
    "0.1",
    "0.2",
    "0.3",
    "0.4",
    "0.5",
    "0.75",
    "1",
    "1.25",
    "1.5",
    "1.75",
    "2",
    "3",
    "4",
    "5",
  ],
};
